import { gql } from "@urql/core";

export const TRADES_QUERY = gql`
  query trades($pageArgs: PageArgs!, $filter: TradeFilter) {
    trades(pageArgs: $pageArgs, filter: $filter) {
      edges {
        cursor
        node {
          type
          pair {
            address
            token {
              logoUrl
              symbol
              address
            }
            baseToken {
              logoUrl
              symbol
              address
            }
          }
          price
          amountToken
          amountBase
          amountNative
          amountUSD
          timestamp
          maker
          transactionHash
          blockNumber
          isNative
          networkId
        }
      }
      pageInfo {
        hasNextPage
        endCursor
        totalCount
      }
      count
    }
  }
`;

export const TRADES_SUBSCRIPTION = gql`
  subscription OnTrade($pair: String!) {
    trades(pair: $pair) {
      type
      pair {
        address
        token {
          logoUrl
          symbol
          address
        }
        baseToken {
          logoUrl
          symbol
          address
        }
      }
      price
      amountToken
      amountBase
      amountNative
      amountUSD
      timestamp
      maker
      transactionHash
      blockNumber
      isNative
      networkId
    }
  }
`;

export const PAIR_QUERY = gql`
  query Pair($input: PairInput!) {
    pair(input: $input) {
      createdAt
      network {
        id
        name
      }
      buyTax
      sellTax
      address
      pairFactory {
        address
        name
        logoURL
      }
      token {
        logoUrl
        name
        symbol
        address
        decimals
        supply
        buyTax
        sellTax
        socialsAt
        telegram
        twitter
        description
        website
        discord
        scamAt
        seenAt
        confirmedAt
        verifiedAt
        tradingAt
        liquidityAt
      }
      baseToken {
        logoUrl
        name
        symbol
        address
        decimals
      }
      volume24h
      liquidity
      priceNative
      priceUSD
      priceUSD24h
      isNative
    }
  }
`;
